import type { CSRFClientPlugin } from './getCSRFClientPlugin';
import type { CSRFServerPlugin } from './getCSRFServerPlugin';

export const getCSRFPlugin: CSRFServerPlugin & CSRFClientPlugin =
    __BUILD_TARGET__ === 'server'
        ? require('./getCSRFServerPlugin').getCSRFServerPlugin
        : require('./getCSRFClientPlugin').getCSRFClientPlugin;
